import { useEffect, useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Star } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function RatingModal({ open, onOpenChange, bookingId, onDone }) {
  const [stars, setStars] = useState(5);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) {
      setStars(5);
      setComment("");
    }
  }, [open]);

  async function submit() {
    setBusy(true);
    try {
      await api.post(`/bookings/${bookingId}/rate`, { stars, comment });
      toast.success("Thanks for your rating!");
      onOpenChange(false);
      onDone?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader><DialogTitle className="bb-display">Rate this session</DialogTitle></DialogHeader>
        <div className="flex justify-center gap-1 py-3">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              onClick={() => setStars(n)}
              aria-label={`${n} stars`}
              data-testid={`rating-star-${n}`}
              className="p-1"
              type="button"
            >
              <Star
                className={`h-8 w-8 ${n <= stars ? "fill-[hsl(var(--accent))] text-[hsl(var(--accent))]" : "text-muted-foreground"}`}
              />
            </button>
          ))}
        </div>
        <Textarea
          placeholder="Leave a comment (optional)"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          data-testid="rating-comment-input"
        />
        <DialogFooter>
          <Button onClick={submit} disabled={busy} data-testid="rating-submit-button">Submit</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
